var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#F3F6F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1199 24.912L20.2479 20.528C20.5892 20.1653 20.8665 19.84 21.0799 19.552C21.2932 19.264 21.4479 18.992 21.5439 18.736C21.6399 18.48 21.6879 18.2187 21.6879 17.952C21.6879 17.4507 21.5225 17.0613 21.1919 16.784C20.8719 16.496 20.4612 16.352 19.9599 16.352C19.4265 16.352 18.9572 16.4853 18.5519 16.752C18.1465 17.0187 17.7839 17.4347 17.4639 18L16.1839 16.944C16.6212 16.1867 17.1599 15.616 17.7999 15.232C18.4399 14.8373 19.1812 14.64 20.0239 14.64C20.7172 14.64 21.3252 14.7787 21.8479 15.056C22.3705 15.3333 22.7759 15.7227 23.0639 16.224C23.3519 16.7147 23.4959 17.2853 23.4959 17.936C23.4959 18.4053 23.4372 18.8267 23.3199 19.2C23.2132 19.5627 23.0265 19.9307 22.7599 20.304C22.4932 20.6667 22.1252 21.0933 21.6559 21.584L18.4879 24.864L16.1199 24.912ZM16.1199 26V24.912L17.7039 24.352H23.7199V26H16.1199Z",
    fill: "#008CB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileStep2);
export default __webpack_public_path__ + "static/media/mobile-step2.5f6d521c71a40e5a577e0a0833562da9.svg";
export { ForwardRef as ReactComponent };